import * as React from 'react'

import {
  Text,
  Spacing,
  StackChildren,
} from '@doordash/design-language'


import t from './strings'
import Button from '@doordash/component-button'
import { IDV_CONTACT_SUPPORT_URL, IDV_FAQ_URL } from '../../../constants'
import { loadUrl } from '../../../webview'
import { FAQLink } from './styles'

type Props = {
    showContactSupport?: boolean
}

const IdentityVerificationAwait: React.FC<Props> = ({ showContactSupport = true }) => {

    return (
        <StackChildren size={Spacing.Large}>
            <Text styles={Text.Styles.MajorPageTitle}>
                {t.idvFail()}
            </Text>
            <Text styles={Text.Styles.PageDescriptionBody}>
                {t.idvFailureSubtext1()}
            </Text>
            <Text styles={Text.Styles.PageDescriptionBody}>
                {t.idvFailureSubtext2()}{' '}
                <FAQLink href={IDV_FAQ_URL} target="_blank"
                >
                    {t.idvFailureFAQ()}
                </FAQLink>
                {' '}{t.idvFailureSubtext3()}
            </Text>
            {
                showContactSupport && 
                <Button href={IDV_CONTACT_SUPPORT_URL} tag="a" target="_blank"
                onClick={() => loadUrl(IDV_CONTACT_SUPPORT_URL)}
                >
                {t.contactSupport()}
                </Button>
            }
        </StackChildren>
    )
}

export default IdentityVerificationAwait
